import i18n from '@/locales'
import { cacheTtlOptions, rateLimitingIntervalOptions } from '../constants'

export const getCollectLogsColumn = () => {
  return {
    title: i18n.t('ai.collect_logs'),
    field: 'collect_logs',
    formatter: ({ row }) => {
      return row.collect_logs ? i18n.t('scope.text_251') : i18n.t('scope.text_252')
    },
  }
}

export const getCacheTtlColumn = () => {
  return {
    title: i18n.t('ai.cache_response'),
    field: 'cache_ttl',
    formatter: ({ row }) => {
      if (!row.cache_ttl) {
        return i18n.t('scope.text_252')
      }
      const target = cacheTtlOptions.filter(item => item.value === row.cache_ttl)
      return target.length ? target[0].label : row.cache_ttl
    },
  }
}

export const getRequestRateLimitColumn = () => {
  return {
    title: i18n.t('ai.request_rate_limit'),
    field: 'request_rate_limit',
    formatter: ({ row }) => {
      if (!row.rate_limiting_interval) {
        return i18n.t('scope.text_252')
      }
      const target = rateLimitingIntervalOptions.filter(item => item.value === row.rate_limiting_interval)
      return i18n.t(`ai.request_rate_limit_technique_${row.rate_limiting_technique}_extra`, [target.length ? target[0].label : row.rate_limiting_interval / 60 + 'Min', row.rate_limiting_limit])
    },
  }
}

export const getAuthenticationColumn = () => {
  return {
    title: i18n.t('ai.enable_authentication'),
    field: 'authentication',
    formatter: ({ row }) => {
      return row.authentication ? i18n.t('scope.text_251') : i18n.t('scope.text_252')
    },
  }
}
